import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/authContext';
import { useDevice } from '../contexts/deviceTypeContext';

const homeCards = [
	{
		icon: '📚',
		heading: 'Interactive Quizzes',
		para: 'Take engaging quizzes across different topics to test understanding and strengthen knowledge.',
	},
	{
		icon: '⏱️',
		heading: 'Timed Challenges',
		para: 'Quizzes are time-based to improve focus, speed, and exam readiness under real conditions.',
	},
	{
		icon: '📈',
		heading: 'Progress Tracking',
		para: 'Track scores, improvements, and learning growth over time in one place.',
	},
	{
		icon: '🎯',
		heading: 'Performance Insights',
		para: 'Detailed results help students understand strengths, weaknesses, and areas to improve.',
	},
	{
		icon: '🏆',
		heading: 'Learning Motivation',
		para: 'Achievements and consistent practice to encourage you stay motivated and aim higher.',
	},
	{
		icon: '🔐',
		heading: 'Secure Student Accounts',
		para: 'Your progress, quiz history, and results are safely stored and protected.',
	},
]
function Home() {
	const { loggedIn } = useAuth()
	const { width } = useDevice();
	// console.log({loggedIn})
	// const { showPage } = useOutletContext();
	return (
		<>
			{/* <div id="home" className="page active">
				<div className="container"> */}
					<>
						<section className="hero glass">
							<div className="hero-image">
								<img src={require("../assets/images/eStudieBuddie.png")} alt="eStudieBuddie media" />
							</div>
							<div className="hero-content">
								<h3 className='hero-header'>Learning just got smarter, simpler, and more fun.</h3>
								<p>
									<AppNameOld paragragh={true} color1='white' color2="font-gold" /> is an All-in-One
									<strong> AI-powered</strong> study and practice platform designed for students
									from <strong>Basic 1-5, JSS 1-3, SSS 1-3</strong>, and candidates preparing for
									<strong> WAEC</strong> and <strong>JAMB</strong>.
								</p>
								<p>Whether you're revising for a class test, practicing past questions, or getting
									exam-ready, our <strong>AI-driven learning system</strong> adapts to your pace
									and helps you focus on what matters most.
								</p>
								<p>
									With <strong>smart AI feedback</strong>, interactive quizzes, timed practice
									sessions, and exam-focused questions
									, <AppNameOld paragragh={true} color1='white' color2="font-gold" /> helps
									you <strong>learn better, track your progress intelligently, and build
									confidence</strong>, one question at a time.
									<span className='device-width-home'>{width}</span>
								</p>
								<div className='d-flex gap-1 center-btns'>
									<Link to={"/quiz"}
									className="cta-button">Take a Test!</Link>
									{!loggedIn ?
									<Link to={"/signup"}
									className="cta-button">Register for Free!</Link>:null}
								</div>
							</div>
						</section>

						<section className="cards">
							{homeCards.map((card, cIdx) => {
								return (
									<div key={cIdx}
									className="card-item glass">
										<div className="icon-item">{card.icon}</div>
										<h3>{card.heading}</h3>
										<p>{card.para}</p>
									</div>
								)
							})}
						</section>
					</>
				{/* </div>
			</div> */}
			{/* <!-- Hero section --> */}
			{/* <Hero /> */}
			{/* <!-- Hero section end --> */}


			{/* <!-- categories section --> */}
			{/* <Categories /> */}
			{/* <!-- categories section end --> */}


			{/* <!-- search section --> */}
			{/* <Search /> */}
			{/* <!-- search section end --> */}


			{/* <!-- course section --> */}
			{/* <CourseSection /> */}
			{/* <!-- course section end --> */}


			{/* <!-- signup section --> */}
			{/* <SignUp /> */}
			{/* <!-- signup section end --> */}

			{/* <!-- banner section --> */}
			{/* <Banner /> */}
			{/* <!-- banner section end --> */}

		</>
	);
}

function AppNameOld({paragragh=false, color1=null, color2=null}) {
	return (
		<span
		className={paragragh?'':'logo-text'}>
			<span className="font-gold skew-e">e</span>
			<span className={`font-${color1?color1:'light-white'}`}>Studie</span>
			<span className={`${color2?color2:'font-gold1'} text-nowrap`}>
				<span className="skew-b">B</span>
				<span className=''>uddie</span>
			</span>
		</span>
	)
}
export { Home };
